import React from "react";
var DEFAULT_LOCALE = "en";
var LocaleContext = React.createContext(DEFAULT_LOCALE);
export default LocaleContext;
